import axios from "axios";
import { ADMIN_PORTAL_API_BASE_URL, ADMIN_PORTAL_AUTH_TOKEN } from "../utils/config";

export const getAppMonitoringData = async (payload) => {
    const url = `${ADMIN_PORTAL_API_BASE_URL}/get_app_monitoring`

    const config = {
        method: "POST",
        url,
        data: payload,
        headers: {
            Authorization: `Bearer ${ADMIN_PORTAL_AUTH_TOKEN}`,
        },
    };

    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        console.error("Error fetching analytics data:", error);
        throw error.response?.data || error;
    }
};
